import { Injectable } from '@angular/core';
import { GlobalDomOpsService, CommonOperationsService, GlobalDataOpsService, AcepSSOService } from '@acepteam/globalspack';
import { DomService, DataService, HelperService, LoggerService } from '../../core/services';
import { Title } from '@angular/platform-browser';
import { HttpClient } from '@angular/common/http';
import { Summary, MemberAppData } from '../../shared/models';
import { MemberType } from '../../shared/enums/data.enums';
import { ChapterInfo } from '../../shared/models/chapter-details';


declare var $: any;
declare var moment: any;


@Injectable(
	{
		providedIn: "root"
	}
)
export class MemberAppDomService {

	constructor(private globalDomOpsService: GlobalDomOpsService, private ssoService: AcepSSOService,
		private domService: DomService,
		private globalDataOpsService: GlobalDataOpsService,
		private dataService: DataService,
		private commonOpsService: CommonOperationsService,
		private helperService: HelperService,
		private titleService: Title,
		private loggerService: LoggerService,
		private http: HttpClient) { }


	initDatePickerPopup() {
		$("app-grad-date > *, mat-datepicker-toggle > *, mat-form-field.datepicker > *").on('click', function (e) {
			//console.log('clicked: ' + $(this));

			if ($(document).find('.cdk-overlay-pane.mat-datepicker-popup').is(':visible')) {
				var dp_left = $(".cdk-overlay-pane.mat-datepicker-popup").css("left");
				var dp_right = $(".cdk-overlay-pane.mat-datepicker-popup").css("right");

				//var calRight = $(".cdk-overlay-pane.mat-datepicker-popup").css("left");
				console.log("left: ", $(".cdk-overlay-pane.mat-datepicker-popup").css("left"), dp_left, parseInt(dp_left), " right: ", $(".cdk-overlay-pane.mat-datepicker-popup").css("right"), dp_right, parseInt(dp_right));
				if (parseInt(dp_right) > parseInt(dp_left)) {
					$(".cdk-overlay-pane.mat-datepicker-popup").css("right", dp_left);
					$(".cdk-overlay-pane.mat-datepicker-popup").css("left", "");
				} else {
					$(".cdk-overlay-pane.mat-datepicker-popup").css("right", dp_right);
					$(".cdk-overlay-pane.mat-datepicker-popup").css("left", "");
				}

				e.preventDefault();
			}
		});

	}
	initPersonalInfoStyles() {
		//$('.FlowupLabels').FlowupLabels();
		//this.globalDomOpsService.hidewait();
		this.initDatePickerPopup();
	}

	initMembershipStyles() {
		//this.globalDomOpsService.hidewait();
	}

	initEducationStyles() {
		// $('.FlowupLabels').FlowupLabels();
		//this.globalDomOpsService.hidewait();
		this.initDatePickerPopup();
	}

	initSectionStyles() {
		// $('.FlowupLabels').FlowupLabels();
		$(".descTrigger").on('click', function (e) {
			$(this).find('i').toggleClass("fa-angle-down fa-angle-up");
			e.preventDefault();

			$(this).closest('.thumbnail').find(".description").slideToggle();
		});
	}

	updatesummaryVisibility(isPageLoad: boolean, routename: string, memberAppData: MemberAppData) {
		//  debugger;
		if (routename.indexOf('changeaddress') > -1) {
			//isPageLoad = true;
			routename = routename.replace("changeaddress", "chapters");
		}


		let $el = $("." + routename + "-summary");
		//Set Title
		let title = `${this.globalDataOpsService.ORG} Member App` + (routename == '' ? '' : '/' + this.helperService.capitalize(routename));
		this.titleService.setTitle(title);
		if (!$el.hasClass('hidethis')) {
			$el.addClass('hidethis')
		}
		//If on notify screen -> It means all navigation is blocked
		if (routename == 'notify') {
			$(".summary").addClass('hidethis');
			$("html,body").scrollTop(0);
			return false;
		}

		$el.prevAll().removeClass('hidethis');

		$el.nextAll(".summary").each(function () {
			if (!$(this).hasClass('hidethis')) {
				$(this).addClass('hidethis')
			}
		});


		//HIDE CHAPTERS FOR INTERNATIONAL
		if (memberAppData.profile.IsInternational) {
			$(".chapters-summary").hide();
		}


		//this.globaldomops.initPlugins();
		this.updateNavSummaryText(memberAppData);

		//Business Rule: International membersh should skip membership tab
		// $el = $(".membertype-summary");
		// if (!$el.hasClass('hidethis') && this.data_pinfo != undefined && this.data_pinfo.Country != 'US') {
		//     $el.addClass('hidethis');
		// }

		// //Business Rule: Students should skip Career tab
		// $el = $(".career-summary");
		// if (!$el.hasClass('hidethis') && this.data_membership != undefined && this.data_membership.FutureMemberTypeCode == SEMPAMembershipType.Student) {
		//     $el.addClass('hidethis');
		// }

		// if(!isPageLoad)
		// {
		this.domService.scrolltosection(isPageLoad);
		// }

	}


	updateNavSummaryText(memberAppData: MemberAppData) {
		let summary: Summary = this.updateSummaries(memberAppData);
		$(".personal-summary p:eq(0)").html(summary.personal);
		$(".membership-summary p:eq(0)").html(summary.memberhip);
		$(".education-summary p:eq(0)").html(summary.education);
		$(".chapters-summary p:eq(0)").html(summary.chapter);
		$(".sections-summary p:eq(0)").html(summary.sections);

	}

	getMemberType(m: MemberType): string {
		let mStr = '';
		switch (m) {
			case MemberType.Student:
				mStr = "Medical Student";
				break;

			case MemberType.Resident:
				mStr = "Resident Physician";
				break;

			case MemberType.Fellow:
				mStr = "Fellowship Physician";
				break;

			case MemberType.Physician:
				mStr = "EM Physician";
				break;

			case MemberType.Retired:
				mStr = "Semi-Retired/Retired";
				break;	

			default:
				break;
		}

		return mStr;
	}

	updateSummaries(d: MemberAppData) {



		let summary: Summary = {
			personal: d.personalInfo ? `<span class="labelBlock">${d.personalInfo.firstName} ${d.personalInfo.lastName}</span><span class="labelBlock">${this.ssoService.acepid}</span><span class="labelBlock">${d.personalInfo.email}</span>` + (d.personalInfo.phone == '' ? '' : `<span class="labelBlock" >${d.personalInfo.phone}</span>`) + `<span class="labelBlock">${d.personalInfo.customerAddress.address.address2} ${d.personalInfo.customerAddress.address.city} ${d.personalInfo.customerAddress.address.state} ${d.personalInfo.customerAddress.address.country} ${d.personalInfo.customerAddress.address.zip}</span>` : '',

			memberhip: d.membershipDetails ? `<span class="labelBlock">${this.getMemberType(d.membershipDetails.memberType)}</span>`
				+ (d.membershipDetails.activeMilitary ? `<span class="labelBlock" >Active Duty Military</span>` : '')
				: '',

			education: d.educationDetails ?
				(d.educationDetails.medicalSchool.id ? `<span class="labelBlock">${d.educationDetails.medicalSchool.name} | ${d.educationDetails.medicalSchool.graduationdate}</span>` : '')
				+ (d.educationDetails.residency.id ? `<span class="labelBlock" >${d.educationDetails.residency.name} | ${d.educationDetails.residency.graduationdate}</span>` : '')
				+ (d.educationDetails.fellowship.id ? `<span class="labelBlock" >${d.educationDetails.fellowship.name} | ${d.educationDetails.fellowship.graduationdate}</span>` : '')
				+ (d.educationDetails.boardCertification.id ? `<span class="labelBlock" >${d.educationDetails.boardCertification.name} | ${d.educationDetails.boardCertification.expirationdate}</span>` : '')
				: '',

			chapter: d.chapterDetails ? d.chapterDetails.chapters.filter(a => a.selected).map(function (e) {
				return `<span class="labelBlock">${e.name}</span>`;
			}).join('') : '',


			sections: d.sectionDetails ? d.sectionDetails.sections.filter(a => a.selected).map(function (e) {
				return `<span class="labelBlock">${e.name}</span>`;
			}).join('') : ''

		}

		if (summary.sections == '') {
			summary.sections = 'None';
		}
		return summary;
	}

}
